import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

const EmailVerificationNeeded = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '50px 0px',
            }}
        >
            <Stack direction="column">
                <Typography
                    variant="h4"
                    sx={{ margin: 'auto' }}
                    data-cy="awaiting-email"
                >
                    Awaiting Email Verification
                </Typography>
                <Typography variant="body1" sx={{ margin: 'auto' }}>
                    This email can take up to 15 minutes to arrive.
                </Typography>
                <Typography variant="body1" sx={{ margin: 'auto' }}>
                    Check your junk mail if you do not see the email soon.
                </Typography>
            </Stack>
        </Box>
    );
};

export default EmailVerificationNeeded;
